
import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import crossBtn from "../../assets/images/clear.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import logoLg from "../../assets/images/lg-logo.png";
import { withRouter, notification } from "../../utils/utility";
import { sendPostRequest } from "../../actions/app-actions";
import {
  getUserDashboardLink,
  getUserRoles,
  getUserBusinesses,
} from "../../utils/authHelper";
import CryptoJS from "crypto-js";
import { USER_TYPE_PREFIX } from "../../utils/prefixes";
import { USER_TYPES } from "../../routes/types/private";
import isEmpty from "../../validation/is-empty";
import setAuthToken from "../../utils/setAuthToken";
import { setCurrentUser } from "../../actions/authActions";

const Google2FA = (props) => {

    const { user_id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const Schema = Yup.object().shape({
        otp: Yup.string()
            .matches(/^\d+$/, 'Security Code must contain digits only')
            .min(6, "Security Code too short!")
            .max(6, "Maximum six digit are allowed")
            .required("Security Code is required.")
    });

    useEffect(() => {
        if (props.auth.isAuthenticated) {
          setIsLoading(false);
          // based on usertype redirect to user specific dashboard
          if (localStorage.userType) {
            navigate(getUserDashboardLink(localStorage.getItem("userType")));
          } else {
            const userRoles = getUserRoles();
            const userBusinesses = getUserBusinesses();
    
            // Getting business ids
            let businessIds = [];
            if (!isEmpty(userBusinesses)) {
              for (let userBusiness in userBusinesses) {
                businessIds.push(userBusinesses[userBusiness]);
              }
            }
    
            if (
              userRoles.length === 1 &&
              (businessIds.length === 0 || businessIds.length === 1)
            ) {
              localStorage.setItem(
                "userType",
                CryptoJS.SHA256(USER_TYPE_PREFIX + userRoles.pop())
              );
              // for admin user save business id in local storage
              if (
                localStorage.userType === USER_TYPES.admin &&
                businessIds.length === 1
              ) {
                localStorage.setItem("businessId", businessIds.pop());
              }
              navigate(getUserDashboardLink(localStorage.getItem("userType")));
            } else {
              navigate("/admin/user-type");
            }
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.auth.isAuthenticated]);
    
    const formikProps = {
        initialValues: {
            otp: "",
        },
        validationSchema: Schema,
        onSubmit: (values, formikHelpers) => {
            setIsLoading(true);
            props.sendPostRequest({
                url: `/verify-2fa`,
                data: {
                    otp: values.otp,
                    user_id
                },
                onSuccess: function (response) {
                    if (response.success) {
                        const { access_token, jwt_custom_claims } = response.data;
                        localStorage.setItem("config", JSON.stringify(jwt_custom_claims));
                        localStorage.setItem("userTimezone", jwt_custom_claims.timezone);
                        localStorage.setItem("userTimezoneId", jwt_custom_claims.timezone_id);
                        localStorage.setItem("page", jwt_custom_claims.page);
                        // Set token to ls
                        localStorage.setItem("jwtToken", access_token);
                        // Set token to Auth header
                        setAuthToken(access_token);
                        dispatch(setCurrentUser(jwt_custom_claims.user));
                    }
                    setIsLoading(false);
                },
                onError: function (error) {
                    const { data } = error.response;
                    if (!data.success) {
                        if (!Array.isArray(data.message)) {
                            notification.error(data.message);
                            formikHelpers.setFieldError(
                                "otp",
                                data.message
                            );
                        }
                    }

                    console.log('error', error);

                    setIsLoading(false);
                },
            });
        },
    };

    return (
        <>
            <Loader isShowLoader={isLoading} />
            <Formik {...formikProps}>
                {(formik) => {
                    const { values, handleChange, handleSubmit, handleBlur } = formik;
                    return (
                        <div className="signup-process">
                            <div className="logo-side">
                                <img src={logoLg} alt="" />
                            </div>
                            <div className="signup">
                                <div className="cross-btn">
                                    <Link to="/">
                                        <img width="33" src={crossBtn} alt="" />
                                    </Link>
                                </div>
                                <div className="signup-form">
                                    <form onSubmit={handleSubmit}>
                                        <h1 className="mb-2">Enter Security Code</h1>
                                        <p className="r-p">Open your authentication app and enter the security code it provides.</p>
                                        <div className="form-group mb-0">
                                        <label className="same-label" htmlFor="email">
                                            Security Code
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control same-input"
                                            name="otp"
                                            id="otp"
                                            placeholder="Enter Security Code"
                                            value={values.otp}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        </div>
                                        <ErrorMessage
                                            name="otp"
                                            render={(error) => <span className="error">{error}</span>}
                                        />
                                        <button type="submit" className="btn btn-app">
                                            Verify
                                        </button>
                                        <p className="login-here">
                                            Don't have a account? <Link to="/signup">SignUp Now</Link>
                                        </p>
                                    </form>
                                </div>
                                <div className="signup-footer">
                                    <ul className="languages d-none">
                                        <li>English (UK)</li>
                                        <li>हिन्दी</li>
                                        <li>ਪੰਜਾਬੀ</li>
                                        <li>বাংলা</li>
                                        <li>Deutsch</li>
                                        <li>ગુજરાતી</li>
                                        <li>Español</li>
                                    </ul>
                                    <p>Copyright © 2025 MeetOcto.</p>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Formik>
        </>
    )

}


const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, {sendPostRequest} )(withRouter(Google2FA));